<template>
    <div @click="show = true">
        <slot name="trigger">
            <a class="button button--salmon-hover">
                <v-icon icon="heart"></v-icon>
                Label
            </a>
        </slot>

        <teleport to="body">
            <div
                v-if="show"
                class="backdrop z-30 items-end md:items-center"
                @click.self="(show = false), closeLightbox()"
            >
                <div
                    class="modal z-40 min-h-[20vh] w-[100vw] rounded-tl-3xl rounded-tr-3xl bg-white md:w-[600px] md:rounded-3xl"
                    :class="[
                        modalClass,
                        { 'max-height': maxed },
                        { footerless: footerless },
                        { 'log-in': !isAuthenticated },
                    ]"
                >
                    <header
                        class="flex select-none items-center justify-between p-8 text-icon-text-medium text-black-78 border-b"
                        :class="[headClass]"
                    >
                        <div class="flex w-8 items-center justify-start"></div>
                        <div class="flex items-center justify-center">
                            <slot name="head"></slot>
                        </div>
                        <div class="flex w-8 items-center justify-end">
                            <div
                                class="flex h-[24px] w-[24px] cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-gray"
                                @click="(show = false), closeLightbox()"
                            >
                                <v-icon icon="close"></v-icon>
                            </div>
                        </div>
                    </header>
                    <template v-if="isAuthenticated">
                        <main class="overflow-y-auto p-8" :class="contentClass">
                            <slot name="content">
                                <div class="p-20"></div>
                            </slot>
                        </main>
                        <footer
                            class="border-t"
                            :class="[
                                footClass
                                    ? 'flex items-center py-4 ' + footClass
                                    : 'justify-center px-7',
                            ]"
                        >
                            <slot name="foot"></slot>
                        </footer>
                    </template>
                    <template v-else>
                        <main
                            class="flex flex-col justify-evenly overflow-y-auto p-8"
                            :class="[contentClass]"
                        >
                            <div class="mx-auto max-w-[358px] lg:pb-7">
                                <div class="mb-3 text-heading-2-mobile">
                                    Za nadaljevanje se prijavite ali
                                    registrirajte
                                </div>
                                <div
                                    class="text-body-regular-mobile text-black-40 max-md:mb-16"
                                >
                                    Shranite svoja iskanja in si poenostavite
                                    brskanje ter prejmite obvestila o ustreznih
                                    novih oglasih.
                                </div>
                            </div>
                            <div class="flex flex-col items-center">
                                <div class="w-full max-w-[240px]">
                                    <a class="button button--form" :href="loginRoute">
                                        Prijavite se
                                        <v-icon
                                            icon="arrow-right-inside-box"
                                        ></v-icon>
                                    </a>
                                </div>
                                <div
                                    class="justficy-center flex w-full items-center pb-8 pt-8"
                                >
                                    <div class="h-[1px] w-full bg-gray"></div>
                                    <div
                                        class="pl-6 pr-6 text-small-text-medium text-black-40"
                                    >
                                        ali
                                    </div>
                                    <div class="h-[1px] w-full bg-gray"></div>
                                </div>
                                <div class="w-full max-w-[240px]">
                                    <a
                                        :href="registerRoute"
                                        class="button button--form button--dark"
                                    >
                                        Registracija
                                        <v-icon icon="user-plus"></v-icon>
                                    </a>
                                </div>
                            </div>
                        </main>
                    </template>
                </div>
            </div>
        </teleport>
    </div>
</template>

<script>
export default {
    props: {
        modalClass: {
            type: String,
        },
        headClass: {
            type: String,
        },
        contentClass: {
            type: String,
        },
        footClass: {
            type: String,
        },
        loginRoute: {
            type: String,
            default: '/prijava'
        },
        registerRoute: {
            type: String,
            default: '/registracija'
        },
        isAuthenticated: {
            type: Boolean,
            default: false,
        },
        maxed: {
            type: Boolean,
            default: false,
        },
        footerless: {
            type: Boolean,
            default: false,
        },
        show: {
            required: false,
            default: false,
        },
    },
    watch: {
        show(value) {
            if (value) {
                document.body.classList.add("lightbox-open");
            } else {
                document.body.classList.remove("lightbox-open");
            }
        },
    },
    methods: {
        closeLightbox() {
            this.$emit("close"); // emit 'close' event to parent
        },
    },
};
</script>
